import {combinedReducers} from "./rootReducer"
import {combinedEpics} from "./rootEpic"

export const listingReducer = combinedReducers
export const listingEpics = combinedEpics


// WEBPACK FOOTER //
// ./src/state/listing/index.ts